import { Badge } from '../ui/badge.tsx';
import type { EndConsumerStatus } from '../../hooks/useEndConsumers.ts';

/**
 * Maps an end-consumer status to its themed Badge. Shared between the
 * consumers table (CustomerConsumersTab) and the edit drawer (EndConsumerDrawer).
 */
export function getStatusBadge(status: EndConsumerStatus) {
  switch (status) {
    case 'invited':
      return <Badge variant='secondary'>Invited</Badge>;
    case 'active':
      return <Badge variant='default'>Active</Badge>;
    case 'disabled':
      return <Badge variant='destructive'>Disabled</Badge>;
  }
}
